<script setup>
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/button-arrow-right.svg';

defineProps({
    iconName: {
        type: String,
        required: true,
    },
    href: {
        type: [String, URL],
        required: false,
        default: null,
    },
    warning: {
        type: Boolean,
        required: false,
        default: false,
    },
    noShadow: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>

<template>
    <Component
        class="dashboard-card"
        :class="{
            'dashboard-card--warning': warning,
            'dashboard-card--shadow': !noShadow,
        }"
        :is="href ? 'a' : 'button'"
        :href="href"
    >
        <SvgIcon
            :name="iconName"
            size="sm"
            role="presentation"
            class="user-dashboard-card__icon"
        />
        <div class="dashboard-card__content">
            <div class="dashboard-card__title">
                <slot />
            </div>
            <div
                class="dashboard-card__description text-muted"
                v-if="$slots.description"
            >
                <slot name="description" />
            </div>
        </div>
        <SvgIcon
            name="button-arrow-right"
            size="mini"
            role="presentation"
            class="dashboard-card__arrow"
        />
    </Component>
</template>
